import script from "./EditAdvertisementForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAdvertisementForm.vue?vue&type=script&setup=true&lang=js"

import "./EditAdvertisementForm.vue?vue&type=style&index=0&id=2978b6d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2978b6d3"]])

export default __exports__